<template>
  <ag-grid-vue  :class="getTheme"
                :columnDefs="columnDefs" 
                :defaultColDef="defaultColDef"   
                :gridOptions="gridOptions"
                :groupDefaultExpanded="-1" 
                :localeText="localeText"
                :pinnedTopRowData="pinnedTopRowData"
                :rowData="rowData"
                :sideBar="sideBar"
                style="width: 100%;"
                :tooltipShowDelay="tooltipShowDelay"
                />
</template>

<script>
  import germanLocale from "./locale.de.js";
  import { i18n } from '@/i18n';
  import "ag-grid-community/dist/styles/ag-grid.css";
  import "ag-grid-community/dist/styles/ag-theme-alpine.css";
  import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
  import "ag-grid-community/dist/styles/ag-theme-balham.css";
  import "ag-grid-community/dist/styles/ag-theme-balham-dark.css";
  import "ag-grid-community/dist/styles/ag-theme-material.css";
  import { AgGridVue } from "ag-grid-vue";
  import 'ag-grid-enterprise';

  import { LicenseManager } from '@ag-grid-enterprise/core'

  export default {
    components: { 
      'ag-grid-vue': AgGridVue
    },

    props: {
      // Von außen injected
      rowData:        { type: Array, default: () => [] },
      // Von außen aus CheckBoxGrid injected
      customColumns:  { type: Object, default: () => ({ active: [], items: [] }) },
      // Vom Host aus injiziert
      columnDefs:     { type: Array, default: () => [] },

      defaultColDef:  { type: Object, default: () => ({ 
        width: 170,
          sortable: true,
          filter: true,
          enableRowGroup: false // custom row grouping
      })},
          
      dynamicColumnDefs: { type: Array, default: () => [] },

      gridOptions: { type: Object, default: () => ({ suppressAggFuncInHeader: true })},

      tooltipShowDelay: { type: Number, default: 500 },

      pinnedTopRowData: { type: Array, default: () => [] },
      
      theme:            { type: String, default: () => 'light' }
    },

    created() {
      this.sideBar = {
        toolPanels: [
          {
            id: 'columns',
            labelDefault: 'Columns',
            labelKey: 'columns',
            iconKey: 'columns',
            toolPanel: 'agColumnsToolPanel',
            toolPanelParams: {
              contractColumnSelection: true,
              suppressColumnFilter: false,
              suppressColumnExpandAll: false,
              suppressColumnSelectAll: false,
              suppressPivotMode: true,
              suppressPivots: false,
              suppressRowGroups: true,
              suppressValues: true,
            },
            width: 400,
          },
          {
            id: 'filters',
            labelDefault: 'Filters',
            labelKey: 'filters',
            iconKey: 'filter',
            toolPanel: 'agFiltersToolPanel',
            width: 400,
          }
        ],
        
        defaultToolPanel: 'columns',
      };
    },

    beforeMount() {
      LicenseManager.setLicenseKey(process.env.VUE_APP_AGGRID);
      this.localeText = i18n.locale == 'de-DE' ? germanLocale : null;
    },

    watch: {
      //TODO: this does not work yet, since the whole ag-grid has to be destroyed and recreated.
      '$i18n.locale': function(newVal) {
        this.localeText = newVal == 'de-DE' ? germanLocale : null;
      }
    },

    computed: {
      getTheme() {
        return this.theme === 'light' 
          ? this.themes.options[0].value
          : this.themes.options[1].value;
      }
    },

    data() {
      return {
        localeText: null,
        themes: {
          options: [ {
            "value": "ag-theme-alpine",
            "text": "ag-theme-alpine"
          }, {
            "value": "ag-theme-alpine-dark",
            "text": "ag-theme-alpine-dark"
          }, {
            "value": "ag-theme-balham",
            "text": "ag-theme-balham"
          }, {
            "value": "ag-theme-balham-dark",
            "text": "ag-theme-balham-dark"
          }, {
            "value": "ag-theme-material",
            "text": "ag-theme-material"
          }],
          selected: "ag-theme-alpine"
        },
        sideBar: null
      }
    }
  }
</script>
